import { all, call, put } from 'redux-saga/effects';

import { GenerateRowAutofill, HandleAutofillValues } from './helpers';
import { send } from '../../helpers/requests';
import { store } from '../store';

import * as actions from './actions';
import * as ClustersActions from '../Clusters/actions';
import * as TimesheetEntriesActions from '../TimesheetEntries/actions';
import { selectToken, selectUserData } from '../selectors';

export function* createTimesheetRowRequestSaga(payload) {
  try {
    const _store = store.getState();
    const userData = selectUserData(_store);
    const token = selectToken(_store);
    const res = yield send({
      url: `/timesheets/${payload.data.timesheetId}/rows`,
      method: 'POST',
      data: payload.data.data,
      token,
    });
    if (userData?.autofillValues?.length > 0) {
      yield HandleAutofillValues({ autofillValues: userData.autofillValues, rowId: res.id, from: 'user' });
    }
    yield put(actions.createTimesheetRowRequestSuccess(res));
  } catch (error) {
    yield put(actions.createTimesheetRowRequestFailure(error));
  }
}

export function* deleteTimesheetRowRequestSaga(payload) {
  try {
    yield send({
      url: `/timesheets/${payload.data.timesheetId}/rows/${payload.data.rowId}`,
      method: 'DELETE',
      token: selectToken(store.getState()),
    });
    yield put(actions.deleteTimesheetRowRequestSuccess({ rowId: payload.data.rowId }));
    yield put(TimesheetEntriesActions.getTimesheetEntriesRequest({ timesheetId: payload.data.timesheetId }));
    yield put(ClustersActions.getClustersRequest({ id: payload.data.timesheetId }));
  } catch (error) {
    yield put(actions.deleteTimesheetRowRequestFailure(error));
  }
}

export function* getTimesheetRowRequestSaga(payload) {
  try {
    const _store = store.getState();
    const res = yield send({
      url: `/timesheets/${payload.data.timesheetId}/rows/${payload.data.rowId}`,
      method: 'GET',
      token: selectToken(_store),
    });
    yield call(GenerateRowAutofill, { res, store: _store });
    yield put(actions.getTimesheetRowRequestSuccess(res));
  } catch (error) {
    yield put(actions.getTimesheetRowRequestFailure(error));
  }
}

export function* getTimesheetRowsRequestSaga(payload) {
  try {
    const _store = store.getState();
    const res = yield send({
      url: `/timesheets/${payload.data.timesheetId}/rows`,
      method: 'GET',
      token: selectToken(_store),
    });
    yield all(res?.map((row) => call(GenerateRowAutofill, { row, store: _store })));
    yield put(actions.getTimesheetRowsRequestSuccess(res));
  } catch (error) {
    yield put(actions.getTimesheetRowsRequestFailure(error));
  }
}

export function* toggleRowBillableRequestSaga(payload) {
  try {
    const res = yield send({
      url: `/timesheets/${payload.data.timesheetId}/rows/${payload.data.rowId}/billable`,
      method: 'PUT',
      data: payload.data.data,
      token: selectToken(store.getState()),
    });
    yield put(actions.toggleRowBillableRequestSuccess(res));
  } catch (error) {
    yield put(actions.toggleRowBillableRequestFailure(error));
  }
}

export function* updateTimesheetRowRequestSaga(payload) {
  try {
    const res = yield send({
      url: `/timesheets/${payload.data.timesheetId}/rows/${payload.data.rowId}`,
      method: 'PUT',
      data: payload.data.data,
      token: selectToken(store.getState()),
    });
    yield put(actions.updateTimesheetRowRequestSuccess(res));
  } catch (error) {
    yield put(actions.updateTimesheetRowRequestFailure(error));
  }
}

export function* updateTimesheetRowDimensionsRequestSaga(payload) {
  try {
    const res = yield send({
      url: `/timesheets/${payload.data.timesheetId}/rows/${payload.data.rowId}/dimension-values`,
      method: 'PUT',
      data: payload.data.data,
      token: selectToken(store.getState()),
    });
    yield put(actions.updateTimesheetRowDimensionsRequestSuccess(res));
  } catch (error) {
    yield put(actions.updateTimesheetRowDimensionsRequestFailure(error));
  }
}
